import { Injectable, HostListener, Inject } from '@angular/core';
import { BehaviorSubject, Observable, Subscriber } from 'rxjs';
import { WINDOW } from "./windows.service";
// Menu
export interface Menu {
	path?: string;
	title?: string;
	icon?: string;
	type?: string;
	badgeType?: string;
	badgeValue?: string;
	active?: boolean;
	bookmark?: boolean;
	children?: Menu[];
}

@Injectable({
	providedIn: 'root'
})

export class NavService {

	public screenWidth: any
	public collapseSidebar: boolean = false

	constructor(@Inject(WINDOW) private window) {
		this.onResize();
		if (this.screenWidth < 991) {
			this.collapseSidebar = true
		}
	}

	// Windows width
	@HostListener("window:resize", ['$event'])
	onResize(event?) {
		this.screenWidth = window.innerWidth;
	}

	MENUITEMS: Menu[] = [
		{
			path: '/', title: 'الصفحة الرئيسية', icon: 'home', type: 'link', badgeType: 'primary', active: false
		},
		{
			title: 'المنتجات', icon: 'box', type: 'sub', active: true, children: [
				{ path: '/products/list-categories', title: 'الاقسام الرئيسية', type: 'link' },
				{ path: '/products/list-sub-categories', title: 'الاقسام الفرعية', type: 'link' },

				{ path: '/products/list-material', title: 'الخامات', type: 'link' },
				{ path: '/products/list-color', title: 'الالوان', type: 'link' },

				{ path: '/products/list-product', title: 'المنتجات', type: 'link' },
				// { path: '/products/physical/product-detail', title: 'Product Detail', type: 'link' },
			]
		},
		{
			title: 'التصميم', icon: 'camera', type: 'sub', active: true, children: [
				{ path: '/design/list-parts', title: 'الفروع', type: 'link' },
				{ path: '/design/list-sliders', title: 'السلايدر', type: 'link' },
				{ path: '/design/list-news', title: 'شريط الاخبار', type: 'link' },
				{ path: '/design/list-phones', title: 'ارقام التليفون', type: 'link' },
			]
		},
		{
			title: 'التقارير', icon: 'bar-chart', type: 'sub', active: true, children: [
				{ path: '/reports/dashboard', title: 'تقرير اليومية', type: 'link' },
				{ path: '/reports/products', title: 'تقرير المنتجات', type: 'link' },
				{ path: '/reports/categories', title: 'تقرير الاقسام', type: 'link' },
				{ path: '/reports/parts', title: 'تقرير الفروع', type: 'link' },
				{ path: '/reports/materials', title: 'تقرير الخامات', type: 'link' },
				{ path: '/reports/colors', title: 'تقرير الالوان', type: 'link' },
				{ path: '/reports/tags', title: 'تقرير الكلمات الدلاليه', type: 'link' },
				{ path: '/reports/countries', title: 'تقرير الدول', type: 'link' },
				// { path: '/products/physical/product-detail', title: 'Product Detail', type: 'link' },
			]
		},
		{
			path: '/', title: 'تسجيل الخروج', icon: 'x', type: 'logout', badgeType: 'primary', active: false
		},
		// {
		// 	title: 'Sales', icon: 'dollar-sign', type: 'sub', active: false, children: [
		// 		{ path: '/sales/orders', title: 'Orders', type: 'link' },
		// 		{ path: '/sales/transactions', title: 'Transactions', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Coupons', icon: 'tag', type: 'sub', active: false, children: [
		// 		{ path: '/coupons/list-coupons', title: 'List Coupons', type: 'link' },
		// 		{ path: '/coupons/create-coupons', title: 'Create Coupons', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Pages', icon: 'clipboard', type: 'sub', active: false, children: [
		// 		{ path: '/pages/list-page', title: 'List Page', type: 'link' },
		// 		{ path: '/pages/create-page', title: 'Create Page', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Media', path: '/media', icon: 'camera', type: 'link', active: false
		// },
		// {
		// 	title: 'Menus', icon: 'align-left', type: 'sub', active: false, children: [
		// 		{ path: '/menus/list-menu', title: 'Menu Lists', type: 'link' },
		// 		{ path: '/menus/create-menu', title: 'Create Menu', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Users', icon: 'user-plus', type: 'sub', active: false, children: [
		// 		{ path: '/users/list-user', title: 'User List', type: 'link' },
		// 		{ path: '/users/create-user', title: 'Create User', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Vendors', icon: 'users', type: 'sub', active: false, children: [
		// 		{ path: '/vendors/list-vendors', title: 'Vendor List', type: 'link' },
		// 		{ path: '/vendors/create-vendors', title: 'Create Vendor', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Localization', icon: 'chrome', type: 'sub', children: [
		// 		{ path: '/localization/translations', title: 'Translations', type: 'link' },
		// 		{ path: '/localization/currency-rates', title: 'Currency Rates', type: 'link' },
		// 		{ path: '/localization/taxes', title: 'Taxes', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Reports', path: '/reports', icon: 'bar-chart', type: 'link', active: false
		// },
		// {
		// 	title: 'Settings', icon: 'settings', type: 'sub', children: [
		// 		{ path: '/settings/profile', title: 'Profile', type: 'link' },
		// 	]
		// },
		// {
		// 	title: 'Invoice', path: '/invoice', icon: 'archive', type: 'link', active: false
		// },
		// {
		// 	title: 'Login',path: '/auth/login', icon: 'log-in', type: 'link', active: false
		// }
	]
	// Array
	items = new BehaviorSubject<Menu[]>(this.MENUITEMS);


}
